import {
    RULES_POST_FAILURE,
    RULES_POST_REQUEST,
    RULES_POST_SUCCESS,
} from 'actions';

const initialState = {
    isFetched: false,
    isFetching: false,
    hasErrors: false,
};

export const rulePostReducer = (state = initialState, action) => {
    const {type, rule} = action;
    switch (type) {
        case RULES_POST_SUCCESS: {return {
            ...state,
            isFetched: true,
            isFetching: false,
            hasErrors: false,
            rule,
        }}

        case RULES_POST_REQUEST: {return {
            ...initialState,
            isFetching: true,
            hasErrors: false,
        }}

        case RULES_POST_FAILURE: {return {
            ...initialState,
            hasErrors: true,
        }}

        default: {return state}
    }
};
